// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"272":"pdfmake","712":"canvg","868":"xlsx"}[chunkId] + "." + {"272":"21ac5b90","712":"73f04852","868":"960094ba"}[chunkId] + ".chunk.js";
};